export default "__VITE_PUBLIC_ASSET__eb220bf1__"